module.exports = __webpack_public_path__ + "img/pin.04e1c675.svg";